
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Clipboard } from '@angular/cdk/clipboard';
import Swal from 'sweetalert2';
import * as moment from 'moment';

import { TeemappTableComponent } from '@teem/shared-component/teemapp-table/teemapp-table.component';
import { SharedDataService } from '@teem/services/shared-data.service';
import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';
import { UserCurrencyPipe } from '@teem/pipes/user-currency.pipe';
import { ngDebounce } from '@teem/decorators/debouce.decorator';
import { InvoiceService } from '@teem/services/invoice.service';
import { LoaderService } from '@teem/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';
import { UserService } from '@teem/services/user.service';
import { Invoice } from '@teem/models/invoice';

import { RecordPaymentModalComponent } from '@teem/invoices-module/modals/record-payment-modal/record-payment-modal.component';

import { RefundPaymentModalComponent } from '@teem/shared-component/refund-payment-modal/refund-payment-modal.component';
import { QuickPaymentModalComponent } from '@teem/invoices-module/modals/quick-payment-modal/quick-payment-modal.component';
import { AddPaymentModalComponent } from '@teem/invoices-module/modals/add-payment-modal/add-payment-modal.component';
import ReceivedPaymentTableSchema from '@teem/invoices-module/classes/received-payment-table-schema';
import InvoicesTableSchema from '@teem/invoices-module/classes/invoices-table-schema';
import DraftsTableSchema from '@teem/invoices-module/classes/drafts-table-schema';
import { InvoiceRefModalComponent } from '@teem/invoices-module/modals/invoice-ref-modal/invoice-ref-modal.component';
import Survicate from '@survicate/survicate-web-package/survicate_widget'
import { environment } from '@teem/environments/environment';
declare var $;

@Component({
  selector: 'app-invoices',
  templateUrl: './invoice-list.component.html',
  styles: ['./invoice-list.component.css'],
  providers: [UserCurrencyPipe]
})
export class InvoiceListComponent implements OnInit {
  @ViewChild('invoicesTableRef') invoicesTableRef: TeemappTableComponent;
  // @ViewChild('receivedPaymentsTableRef') receivedPaymentsTableRef: TeemappTableComponent;
  @ViewChild('draftsTableRef') draftsTableRef: TeemappTableComponent;

  activeTab: string = 'all-invoices';
  invoicesCount: number = 0;
  receivedPaymentsCount: number = 0;
  draftsCount: number = 0;
  activeInvoice: any;
  allInvoices: any;
  closedInvoices: any;
  pendingInvoices: any;
  routeSubscriber: any;
  selectedClientUid: string;
  selectedInvoiceUuid: string;
  isInvoiceSelected: boolean = false;
  isDraftSelected: boolean = false;
  userInfo: any;
  permissions: any;
  triggerInvoice: boolean = false;

  // Invoice table variables
  invoicesTable: InvoicesTableSchema = new InvoicesTableSchema(this);
  invoiceMenuItems: Array<any> = [
    // { key: "pay_invoice", label: $localize`:@@ts.pay_invoices:Pay invoices`, onClick: this.payInvoices.bind(this) },
    { key: "view_invoice", label: $localize`:@@ts.view_invoices:View/Print invoices`, onClick: this.viewInvoice.bind(this), singleOnly: true, visible: true },
    { key: "email_invoice", label: $localize`:@@ts.email_invoices:Email invoices`, onClick: this.emailInvoices.bind(this) },
    { key: "whatsapp", label: $localize`:@@ts.whatsapp_invoice:Whatsapp Invoices`, onClick: this.whatsappInvoices.bind(this), visible: true },
    { key: "delete_invoice", label: $localize`:@@ts.delete_invoices:Delete invoices`, onClick: this.deleteInvoices.bind(this) },
    { key: "mark_as_sent_invoice", label: $localize`:@@ts.mark_as_sent:Mark as sent`, onClick: this.markAsSent.bind(this) },
    // {key:"mark_as_view_invoice", label: $localize`:@@ts.mark_as_viewed:Mark as viewed`, onClick: this.markAsViewed.bind(this)},
    { key: "add_online_payment", label: $localize`:@@ts.add_online_payment:Add Online Payment`, onClick: this.addOnlinePayment.bind(this), singleOnly: true, visible: true }
  ];

  // Drafts table variables
  draftsTable: DraftsTableSchema = new DraftsTableSchema(this);
  draftMenuItems: Array<any> = [
    { key: "save_as_invoice", label: $localize`:@@ts.save_as_invoice:Save as Invoice`, onClick: this.draftSaveAsInvoice.bind(this) },
    { key: "delete_invoice", label: $localize`:@@ts.delete_invoices:Delete Invoice`, onClick: this.deleteInvoices.bind(this) },
    { key: "view_invoice", label: $localize`:@@ts.view_draft:View Draft`, onClick: this.viewInvoice.bind(this), singleOnly: true }
  ];

  // Received payments table scheme
  receivedPaymentsTable: ReceivedPaymentTableSchema = new ReceivedPaymentTableSchema(this);
  invoiceRowData: any;

  constructor(
    private invoiceService: InvoiceService,
    private modalService: NgbModal,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private currencyPipe: UserCurrencyPipe,
    private router: Router,
    private userService: UserService,
    private clipboard: Clipboard,
    private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.loadCommonData();

    this.routeSubscriber = this.route.queryParams.subscribe(params => {
      // Defaults to 0 if no query param provided.
      if (params && params['create-invoice']) {
        this.activeTab = "create-invoice";
        this.selectedClientUid = params.client;
      }

      if (params?.uuid) {
        this.selectedInvoiceUuid = params.uuid;
        this.viewInvoice([this.selectedInvoiceUuid]);
      }
    });

    // Show/Hide whatsapp action as per pro plan
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data) {
        if (data.userInfo) {
          Survicate.init({
            workspaceKey: environment?.survicate_key,
            disableTargeting: true,
            traits: {
              id: data.userInfo.id,
              email: data.userInfo.email
            }
          });
          this.userInfo = data.userInfo
          let addOnlinePaymentMenu: any = this.invoiceMenuItems.find(menu => menu.key == "add_online_payment");
          addOnlinePaymentMenu.visible = data.userInfo && data.userInfo.halala_mobile;
        }

        if (data.permissions) {
          this.permissions = data.permissions;
        }
      }
    })
  }

  loadCommonData() {
    this.invoiceService.stats().subscribe((data: any) => {
      if (data.all == 0) {
        this.triggerInvoice = true;
      }
      this.allInvoices = data.total;
      this.closedInvoices = data.closed;
      this.pendingInvoices = data.pending;
    })
  }

  fetchPermissions() {
    this.userService.getPermissions().subscribe((data: any) => {
      if (data) {
        this.sharedDataService.setItem('permissions', data);
      }
    });
  }

  filterByDate(params) {

    if (!(params.from_date || params.to_date)) {
      // On clear button click - Because we can't reset date filter individually for each table so here reload all tables when clear btn clicked.
      this.invoicesTableRef.resetDateFilters();
      // this.receivedPaymentsTableRef.resetDateFilters();
      // this.draftsTableRef.resetDateFilters();

      this.invoicesTableRef.getPage(1);
      // this.receivedPaymentsTableRef.getPage(1);
      // this.draftsTableRef.getPage(1);
    } else if (params.from_date && params.to_date) {
      this.invoicesTableRef.getPage(1, false, params);
      // if (this.activeTab == 'all-invoices') {
      //   this.invoicesTableRef.getPage(1, false, params);
      // } else
      //   // if (this.activeTab == 'received-payments') {
      //   //   this.receivedPaymentsTableRef.getPage(1, false, params);
      //   // } else
      //   if (this.activeTab == 'drafts') {
      //     this.draftsTableRef.getPage(1, false, params);
      //   }
    }
  }

  // function called after 2s
  @ngDebounce(500)
  filterByAmount(params) {
    // if (params.min_amount || params.max_amount) {

    if (this.activeTab == 'all-invoices') {
      this.invoicesTableRef.getPage(1, false, params);
    } else
      // if (this.activeTab == 'received-payments') {
      //   this.receivedPaymentsTableRef.getPage(1, false, params);
      // } else
      if (this.activeTab == 'drafts') {
        this.draftsTableRef.getPage(1, false, params);
      }
    // }
  }

  filterByStatus(params) {
    // if (params.invoice_status) {
      const filteredParams = {
        invoice_status: params?.invoice_status
      };
      
      if (this.activeTab == 'all-invoices') {
        this.invoicesTableRef.getPage(1, false, filteredParams);
      } else if (this.activeTab == 'drafts') {
        this.draftsTableRef.getPage(1, false, filteredParams);
      }
    // } else {
    //   if (this.activeTab == 'all-invoices') {
    //     this.invoicesTableRef.getPage(1, false, {});
    //   } else if (this.activeTab == 'drafts') {
    //     this.draftsTableRef.getPage(1, false, {});
    //   }
    // }
  }

  ngOnDestroy() {
    this.routeSubscriber.unsubscribe();
  }

  switchTab(tab) {
    if (tab == "create-invoice" && this.permissions && !this.permissions.create_invoice) {
      Swal.fire(i18n.invoice.upgrade_account_to_create_more_invoice, "", 'warning');
      return;
    }
    this.activeInvoice = false;
    this.invoiceRowData = null;
    this.activeTab = tab;

    this.invoicesTableRef.reset();
    // this.receivedPaymentsTableRef.reset();
    // this.draftsTableRef.reset();

    // Remove URL query paramerters
    if (this.route.snapshot.queryParams['create-invoice']) {
      this.selectedClientUid = null;
      this.router.navigateByUrl('invoices');
    }
  }

  invoiceActions(action, invoice: any) {
    this.invoiceRowData = invoice;
    switch (action) {
      case INVOICE_ACTIONS.VIEW:
        this.viewInvoice([invoice.uuid])
        break;
      case INVOICE_ACTIONS.EDIT:
        this.onEditInvoice([invoice.uuid])
        break;
      case INVOICE_ACTIONS.DELETE:
        this.deleteInvoices([invoice.uuid])
        break;
      case INVOICE_ACTIONS.RECORD_PAYMENT:
        this.recordNewPayment(invoice)
        break;
      case INVOICE_ACTIONS.CONFIRM_PAYMENT:
        this.confirmPayment(invoice)
        break;
      case INVOICE_ACTIONS.DELETE_PAYMENT:
        this.deletePayments(invoice.uuid)
        break;
      case INVOICE_ACTIONS.RESEND_PAYMENT:
        this.resendPayments(invoice.uuid)
        break;
      case INVOICE_ACTIONS.RE_CALL:
        this.reCallInvoice(invoice.uuid)
        break;
      case INVOICE_ACTIONS.COPY_CLIPBOARD:
        this.generateInvoiceLink(invoice.payment_refer_number);
        break;
      case INVOICE_ACTIONS.SAVE_AS_INVOICE:
        this.draftSaveAsInvoice([invoice.uuid])
        break;
      case INVOICE_ACTIONS.COPY_LINK:
        this.copyShareLink();
        break;
      case INVOICE_ACTIONS.REFUND_PAYMENT:
        this.refundPayment(invoice)
        break;
      case INVOICE_ACTIONS.REFUND_ONLINE_PAYMENT:
        this.refundOnlinePayment(invoice.uuid)
        break;
      case INVOICE_ACTIONS.PDF_INVOICE:
        this.pdfInvoice(invoice.uuid)
        break;
      case INVOICE_ACTIONS.XML_INVOICE:
        this.xmlInvoice(invoice.uuid)
        break;
      case INVOICE_ACTIONS.CANCEL:
        this.cancelInvoice(invoice.uuid)
        break;
    }
  }

  copyShareLink() {
    try {
      this.clipboard.copy(this.invoiceRowData.share_link);
      Swal.fire(i18n.done, i18n.invoice.invoice_copied_to_clipboard, 'success');
    } catch (err) {
      console.error(err);
    }
  }

  generateInvoiceLink(invoiceRefNum) {
    const modalRef = this.modalService.open(InvoiceRefModalComponent);

    // Set id on modal dialog
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "quick-payment";
    modalRef.componentInstance.invoiceRefNum = invoiceRefNum;
    modalRef.componentInstance.onSuccess = () => {

    };

    modalRef.result.then(result => {

    }, fallbackResult => {

    })
  }


  onSelectInvoices(selected: Array<any>) {
    this.invoiceMenuItems.forEach(menu => menu.visible = true);

    let showMarkAsSent = false;
    let showMarkAsViewed = false;
    let showAddOnlinePayment = false;
    let showWhatsapp = true;
    let showPayInvoice = false
    let haveClient = false;
    let showSendEmail = false;

    selected.forEach((item) => {
      if (!item.sent_at)
        showMarkAsSent = true;

      if (!item.viewed_at && item.client_has_email)
        showMarkAsViewed = true;

      if (item.client_has_email)
        showSendEmail = true;

      if (item.client_name != 'Unknown Client')
        haveClient = true;

      if (item.due_amount && parseFloat(item.due_amount) > 0 && this.userInfo.halala_mobile)
        showAddOnlinePayment = true;

      if (item.due_amount && parseFloat(item.due_amount) > 0)
        showPayInvoice = true;
    })
    if (haveClient) {
      let markAsSentMenu: any = this.invoiceMenuItems.find(menu => menu.key == "mark_as_sent_invoice");
      let addOnlinePaymentMenu: any = this.invoiceMenuItems.find(menu => menu.key == "add_online_payment");
      let whatsappMenu: any = this.invoiceMenuItems.find(menu => menu.key == "whatsapp");
      let payInvoiceMenu: any = this.invoiceMenuItems.find(menu => menu.key == "pay_invoice");
      let sendEmailInvoiceMenu: any = this.invoiceMenuItems.find(menu => menu.key == "email_invoice");

      sendEmailInvoiceMenu.visible = showSendEmail;
      markAsSentMenu.visible = showMarkAsSent;
      addOnlinePaymentMenu.visible = showAddOnlinePayment;
      whatsappMenu.visible = showWhatsapp;
      payInvoiceMenu.visible = showPayInvoice;
    } else {
      this.invoiceMenuItems.forEach(menu => menu.visible = false);

      let viewMenu: any = this.invoiceMenuItems.find(menu => menu.key == "view_invoice");
      let deleteMenu: any = this.invoiceMenuItems.find(menu => menu.key == "delete_invoice");

      viewMenu.visible = true;
      deleteMenu.visible = true;
    }

    this.isInvoiceSelected = selected.length > 0;
  }

  onSelectDraft(selected: Array<any>) {
    this.isDraftSelected = selected.length > 0;
  }

  toggleTableMenu() {
    if (this.activeTab == 'all-invoices') {
      if (this.isInvoiceSelected) {
        this.invoicesTableRef.toggleMenu();
      } else {
        Swal.fire(i18n.invoice.please_select_invoice);
      }
    } else if (this.activeTab == 'drafts') {
      if (this.isDraftSelected) {
        this.draftsTableRef.toggleMenu();
      } else {
        Swal.fire(i18n.invoice.please_select_draft);
      }
    }
  }

  onLoadInvoices(data: any) {
    this.invoicesCount = data.totalItems ? data.totalItems : 0;

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }

  onLoadReceivedPayments(data: any) {
    this.receivedPaymentsCount = data.totalItems ? data.totalItems : 0;

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }

  onLoadDrafts(data: any) {
    this.draftsCount = data.totalItems ? data.totalItems : 0;

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }

  onSubmitCreateInvoice(data: any) {
    this.loadCommonData();
    this.fetchPermissions();

    if (this.triggerInvoice) {
      Survicate.showSurvey(environment?.survey?.firstInvoice, { forceDisplay: true });
    }

    this.activeTab = 'all-invoices';
    this.invoicesTableRef.getPage(1);

    // if (data.action == 'draft') {
    //   this.activeTab = 'drafts';
    //   this.draftsTableRef.getPage(1);
    // } else {
    //   this.activeTab = 'all-invoices';
    //   this.invoicesTableRef.getPage(1);
    //   // if (data.include_online_payment)
    //   // this.receivedPaymentsTableRef.getPage(1);
    // }

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 100);

    if (this.route.snapshot.queryParams['create-invoice']) {
      this.selectedClientUid = null;
      this.router.navigateByUrl('invoices');
    }
  }

  onSubmitEditInvoice(data: any) {
    this.loadCommonData();
    this.fetchPermissions();
    // Removed draft list and keep only all invoice list
    this.activeTab = 'all-invoices';
    this.invoicesTableRef.getPage(1);

    // if (data == 'draft') {
    //   this.activeTab = 'drafts';
    //   this.activeTab = 'all-invoices';
    // } else {
    //   this.activeTab = 'all-invoices';
    // }

    // this.draftsTableRef.getPage(1);
    // this.invoicesTableRef.getPage(1);
    // // this.receivedPaymentsTableRef.getPage(1);

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 100);
  }

  editInvoice(invoice: Invoice) {
    this.activeInvoice = invoice;
    this.activeTab = "edit-invoice";
  }

  onDeleteInvoice(invoice: Invoice) {
    this.deleteInvoices([invoice.uuid]);
    // this.activeInvoice = false;
  }

  doAction(obj: any) {
    switch (obj.action) {
      case "email":
        this.emailInvoices([obj.invoice.uuid]);
        break;
      case "whatsapp":
        this.whatsappInvoices([obj.invoice.uuid]);
        break;
      case "pay":
        this.payInvoices([obj.invoice.uuid]);
        break;
      case "validate_zatca_invoice":
        this.validateZatcaInvoice(obj.invoice.uuid);
        break;
      case "push_to_fatoora":
        this.pushToFatoora(obj.invoice.uuid);
        break;
    }
  }

  searchInvoices(term: string) {
    if (this.activeTab == 'all-invoices') {
      this.invoicesTableRef.search.next(term);
    } else
      // if (this.activeTab == 'received-payments') {
      //   this.receivedPaymentsTableRef.search.next(term);
      // } else
      if (this.activeTab == 'drafts') {
        this.draftsTableRef.search.next(term);
      }
  }

  onEditInvoice(selectedInvoices: Array<string>) {
    if (selectedInvoices.length === 1) {
      this.loaderService.startLoading();
      this.invoiceService.get(selectedInvoices[0]).subscribe((invoice: Invoice) => {
        this.activeInvoice = invoice;
        this.activeTab = "edit-invoice";
        this.loaderService.stopLoading();
      }, err => {
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        this.loaderService.stopLoading();
      })
    }
  }

  viewInvoice(selectedInvoices: Array<string>) {
    if (selectedInvoices.length === 1) {
      this.loaderService.startLoading();
      this.invoiceService.get(selectedInvoices[0]).subscribe((invoice: Invoice) => {
        this.activeInvoice = invoice;
        this.activeTab = "view-invoice";
        this.loaderService.stopLoading();
      }, err => {
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        this.loaderService.stopLoading();
      })
    }
  }


  reCallInvoice(selectedInvoice) {
    if (selectedInvoice) {
      this.loaderService.startLoading();
      this.invoiceService.reCallInvoiceInfo(selectedInvoice).subscribe((invoice: Invoice) => {
        this.activeInvoice = invoice;
        this.activeTab = "recall-invoice";
        this.loaderService.stopLoading();
      }, err => {
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        this.loaderService.stopLoading();
      })
    }
  }


  payInvoices(selectedInvoices: Array<string>) {
    if (selectedInvoices.length) {
      this.loaderService.startLoading();
      this.invoiceService.action({ 'do': INVOICE_ACTIONS.PAY, 'ids': selectedInvoices }).subscribe(data => {
        this.loaderService.stopLoading();
        this.activeTab = "all-invoices";
        Swal.fire(i18n.done, i18n.invoice.invoice_paid, 'success');

        this.invoicesTableRef.getPage(1);
        // this.receivedPaymentsTableRef.getPage(1);
        this.loadCommonData();

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  payIncash(obj: any) {

    let todaysDate = new Date();
    let fb = {
      invoice_id: obj.details.id,
      client_id: obj.details.client_id,
      invoice_number: obj.details.invoice_number,
      date: todaysDate,
      amount: obj.details.due_amount,
      payment_type: obj.payment_method
    };

    this.loaderService.startLoading();
    this.invoiceService.createPayment(fb).subscribe(data => {
      this.loaderService.stopLoading();
      this.activeTab = "all-invoices";
      Swal.fire(i18n.done, i18n.invoice.invoice_paid, 'success');
      this.invoicesTableRef.getPage(1);
      // this.receivedPaymentsTableRef.getPage(1);
      this.loadCommonData();

    }, err => {
      this.loaderService.stopLoading();

      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    });

  }


  emailInvoices(selectedInvoices: Array<string>) {
    if (selectedInvoices.length) {
      this.loaderService.startLoading();

      this.invoiceService.action({ 'do': INVOICE_ACTIONS.EMAIL, 'ids': selectedInvoices }).subscribe(data => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.done, i18n.email_sent, 'success');
        this.invoicesTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  whatsappInvoices(selectedInvoices: Array<string>) {
    if (selectedInvoices.length) {
      this.loaderService.startLoading();

      this.invoiceService.action({ 'do': INVOICE_ACTIONS.WHATSAPP, 'ids': selectedInvoices }).subscribe(data => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.done, i18n.invoice.whatsapp_message_sent, 'success');

      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  deleteInvoices(selectedInvoices: Array<string>) {
    if (selectedInvoices.length) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.invoice.you_want_to_delete_invoice,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
          i18n.yes,
        cancelButtonText:
          i18n.no_cancel_it
      }).then(result => {
        if (result.value) {

          this.loaderService.startLoading();

          this.invoiceService.action({ 'do': INVOICE_ACTIONS.DELETE, 'ids': selectedInvoices }).subscribe(data => {
            this.loaderService.stopLoading();
            this.invoicesTableRef.getPage(1);

            // if (this.activeTab == 'all-invoices') {
            //   this.invoicesTableRef.getPage(1);
            // } else if (this.activeTab == 'drafts') {
            //   this.draftsTableRef.getPage(1);
            // } else {
            //   this.activeTab = 'all-invoices';
            //   this.invoicesTableRef.getPage(1);
            //   this.draftsTableRef.getPage(1);
            // }

            Swal.fire(i18n.deleted, selectedInvoices.length == 1 ? i18n.invoice.invoice_deleted : i18n.invoice.invoices_deleted, 'success');

            this.loadCommonData();
            this.fetchPermissions();

          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }
  }

  cancelInvoice(selectedInvoices: Array<string>) {
    console.log(selectedInvoices);
    if (selectedInvoices.length) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.invoice.you_want_to_cancel_invoice,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
          i18n.yes,
        cancelButtonText:
          i18n.no_cancel_it
      }).then(result => {
        if (result.value) {
          this.loaderService.startLoading();

          this.invoiceService.action({ 'do': INVOICE_ACTIONS.CANCEL, 'ids': selectedInvoices }).subscribe((data:any) => {
            this.loaderService.stopLoading();
            this.invoicesTableRef.getPage(1);

            Swal.fire(i18n.cancel, data.message, 'success');

            this.loadCommonData();
            this.fetchPermissions();

          }, (err : any) => {
            this.loaderService.stopLoading();
            const errorMsg = err?.error?.message || err?.message || i18n.getError(err);
            Swal.fire(i18n.alert.error, errorMsg, 'error');
          });
        }
      });
    }
  }

  deletePayments(selectedInvoices: string) {
    if (selectedInvoices.length) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.invoice.you_want_to_delete_invoice,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
          i18n.yes,
        cancelButtonText:
          i18n.no_cancel_it
      }).then(result => {
        if (result.value) {

          this.loaderService.startLoading();

          this.invoiceService.deletePayment(selectedInvoices).subscribe(data => {
            this.loaderService.stopLoading();
            this.invoicesTableRef.getPage(1);
            // // if (this.activeTab == 'received-payments') {
            // // this.receivedPaymentsTableRef.getPage(1);
            // // } else
            // if (this.activeTab == 'all-invoices') {
            //   this.invoicesTableRef.getPage(1);
            // } else if (this.activeTab == 'drafts') {
            //   this.draftsTableRef.getPage(1);
            // } else {
            //   // this.activeTab = 'received-payments';
            //   // this.receivedPaymentsTableRef.getPage(1);
            //   this.invoicesTableRef.getPage(1);
            //   this.draftsTableRef.getPage(1);
            // }

            Swal.fire(i18n.deleted, selectedInvoices.length == 1 ? i18n.invoice.invoice_deleted : i18n.invoice.invoices_deleted, 'success');

            this.loadCommonData();
            this.fetchPermissions();

          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }
  }

  resendPayments(selectedInvoices: string) {
    if (selectedInvoices.length) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.invoice.you_want_to_resend_invoice_payment,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
          i18n.yes,
        cancelButtonText:
          i18n.no_cancel_it
      }).then(result => {
        if (result.value) {

          this.loaderService.startLoading();

          this.invoiceService.resendPayment(selectedInvoices).subscribe(data => {
            this.loaderService.stopLoading();

            // this.activeTab = 'received-payments';
            // this.receivedPaymentsTableRef.getPage(1);
            this.invoicesTableRef.getPage(1);
            // this.draftsTableRef.getPage(1);

            Swal.fire(i18n.done, i18n.invoice.resend_payment, 'success');

            this.loadCommonData();
            this.fetchPermissions();

          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }
  }

  markAsSent(selectedInvoices: Array<string>) {
    if (selectedInvoices.length) {
      this.loaderService.startLoading();

      this.invoiceService.action({ 'do': INVOICE_ACTIONS.MARK_AS_SENT, 'ids': selectedInvoices }).subscribe(data => {
        Swal.fire('', i18n.invoice.invoice_marked_as_sent, 'success');
        this.invoicesTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  markAsViewed(selectedInvoices: Array<string>) {
    if (selectedInvoices.length) {
      this.loaderService.startLoading();

      this.invoiceService.action({ 'do': INVOICE_ACTIONS.MARK_AS_VIEWED, 'ids': selectedInvoices }).subscribe(data => {
        Swal.fire('', i18n.invoice.invoice_marked_as_viewed, 'success');
        this.invoicesTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  draftSaveAsInvoice(selectedInvoices: Array<string>) {
    if (selectedInvoices.length) {

      // if (this.userInfo.subscription && this.userInfo.subscription.subscription_plan != 'pro') {
        // if (this.permissions && !(this.permissions.create_invoice && this.permissions.pending_invoices >= selectedInvoices.length)) {
        //   Swal.fire(i18n.invoice.upgrade_account_to_create_more_invoice, "", 'warning');
        //   return;
        // }
      // }

      if (this.permissions && !this.permissions.create_invoice) {
        Swal.fire(i18n.invoice.upgrade_account_to_create_more_invoice, "", 'warning');
        return;
      }

      this.loaderService.startLoading();

      this.invoiceService.action({ 'do': INVOICE_ACTIONS.SAVE_AS_INVOICE, 'ids': selectedInvoices }).subscribe(data => {
        Swal.fire('', i18n.invoice.invoice_moved_to_all_invoices, 'success');
        this.invoicesTableRef.getPage(1);
        // this.draftsTableRef.getPage(1);
        this.loadCommonData();
        this.fetchPermissions();
      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  recordPayment() {
    const modalRef = this.modalService.open(RecordPaymentModalComponent);

    // Set id on modal dialog
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "recordpayment";
    modalRef.componentInstance.userInfo = this.userInfo;

    modalRef.result.then(result => {
      this.invoicesTableRef.getPage(1);
      // this.receivedPaymentsTableRef.getPage(1);
      this.loadCommonData();
    }, fallbackResult => {

    })
  }

  refundOnlinePayment(selectedInvoices: string) {
    if (this.invoiceRowData) {
      Swal.fire({
        // icon: 'warning',
        title: i18n.invoice.confirm_refund,
        html: i18n.invoice.proceed_with_refund_confirmation,
        input: 'text',
        inputPlaceholder: i18n.invoice.type_refund_confirm,
        inputAttributes: { style: 'text-align: center;' },
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: i18n.invoice.proceed,
        cancelButtonText: i18n.no_cancel_it,
        preConfirm: (value) => {
          if (value !== 'REFUND') {
            Swal.showValidationMessage(i18n.invoice.you_must_type_refund_to_proceed);
          }
          return value;
        }
      }).then((result) => {
        if (result.value) {
          this.loaderService.startLoading();
          this.invoiceService.refundOnlinePayment(selectedInvoices).subscribe(data => {
            this.loaderService.stopLoading();
            this.invoicesTableRef.getPage(1);
            Swal.fire(i18n.done, i18n.payment.update_successfully, 'success');
          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }
  }

  refundPayment(data: any) {
    if (this.invoiceRowData) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.invoice.you_want_to_update_invoice,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
          i18n.yes,
        cancelButtonText:
          i18n.no_cancel_it
      }).then(result => {
        if (result.value) {

          const modalRef = this.modalService.open(RefundPaymentModalComponent);
          // Set id on modal dialog
          modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "recordpayment";
          modalRef.componentInstance.userInfo = this.userInfo;

          modalRef.componentInstance.invoice = this.invoiceRowData;

          modalRef.result.then(result => {
            this.invoicesTableRef.getPage(1);
            // this.receivedPaymentsTableRef.getPage(1);
            this.loadCommonData();
          }, fallbackResult => {

          })
        }
      });
    }


  }

  recordNewPayment(data: any) {
    const modalRef = this.modalService.open(RecordPaymentModalComponent);

    // Set id on modal dialog
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "recordpayment";
    modalRef.componentInstance.userInfo = this.userInfo;
    modalRef.componentInstance.invoice = this.invoiceRowData;

    modalRef.result.then(result => {
      this.invoicesTableRef.getPage(1);
      this.viewInvoice([this.invoiceRowData.uuid]);
      // this.receivedPaymentsTableRef.getPage(1);
      this.loadCommonData();
    }, fallbackResult => {

    })
  }

  addOnlinePayment(selected: Array<string>, row?: any) {
    let invoice: any = this.invoicesTableRef.data.find((invoice: any) => invoice.uuid == selected[0]);
    if (invoice) {

      if (!invoice.client_has_email) {
        Swal.fire('', i18n.t('error.add_online_payment_without_client_email'), 'info');
        return;
      }

      const modalRef = this.modalService.open(AddPaymentModalComponent);
      modalRef.componentInstance.invoice = invoice;

      modalRef.result.then(result => {
        if (result) {
          let fd = {
            invoice_uuid: selected[0],
            amount: result,
            payment_type: 'credit-card',
            date: moment().format('YYYY-MM-DD')
          }

          this.loaderService.startLoading();
          this.invoiceService.createPayment(fd).subscribe(data => {
            this.loaderService.stopLoading();

            Swal.fire('', i18n.invoice.payment_saved, 'success');

            // this.receivedPaymentsTableRef.getPage(1);
            this.invoicesTableRef.getPage(1);
            this.loadCommonData();

          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          })
        }
      }, fallbackResult => {

      })
    }
  }

  quickPayment() {
    const modalRef = this.modalService.open(QuickPaymentModalComponent);

    // Set id on modal dialog
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "quick-payment";
    modalRef.componentInstance.onSuccess = () => {
      this.invoicesTableRef.getPage(1);
      // this.receivedPaymentsTableRef.getPage(1);
    };

    modalRef.result.then(result => {
      this.invoicesTableRef.getPage(1);
      // this.receivedPaymentsTableRef.getPage(1);
    }, fallbackResult => {

    })
  }

  pdfInvoice(uuid: any) {
    (window as any).open(`${environment.baseUrl}/download-invoice/${uuid}/pdf?lang=${(window as any).LOCALE}`, '_blank');
  }

  xmlInvoice(uuid: any) {
    (window as any).open(`${environment.baseUrl}/download-invoice/${uuid}/xml`, '_blank');
  }

  confirmPayment(data: any) {
    this.router.navigateByUrl('/payments');
  }

  validateZatcaInvoice(uuid: any) {
    if (uuid) {
      this.loaderService.startLoading();
      this.invoiceService.action({ 'do': INVOICE_ACTIONS.VALIDATE_ZATCA_INVOICE, 'ids': uuid }).subscribe(data => {
        this.loaderService.stopLoading();
        this.viewInvoice([uuid]);
        Swal.fire(i18n.done, 'Invoice validated successfully', 'success');
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  pushToFatoora(uuid: any) {
    if (uuid) {
      this.loaderService.startLoading();
      this.invoiceService.action({ 'do': INVOICE_ACTIONS.PUSH_FATOORA, 'ids': uuid }).subscribe(data => {
        this.loaderService.stopLoading();
        this.viewInvoice([uuid]);
        Swal.fire(i18n.done, i18n.pushed_to_fatoora, 'success');
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

}
